__turbopack_context__.v({
  "header": "ZFQVQq_header",
  "impactWrapper": "ZFQVQq_impactWrapper",
  "mobileListHeader": "ZFQVQq_mobileListHeader",
  "orgInfo": "ZFQVQq_orgInfo",
  "printLink": "ZFQVQq_printLink",
  "summation": "ZFQVQq_summation",
  "taxMessageInfo": "ZFQVQq_taxMessageInfo",
});
